import { render, staticRenderFns } from "./MobilePageSelect.vue?vue&type=template&id=644b42b3&scoped=true"
import script from "./MobilePageSelect.vue?vue&type=script&lang=js"
export * from "./MobilePageSelect.vue?vue&type=script&lang=js"
import style0 from "./MobilePageSelect.vue?vue&type=style&index=0&id=644b42b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b42b3",
  null
  
)

export default component.exports